import React from "react";
import "./App.scss";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Main from "./containers/Main";
import ProjectPage from "./containers/ProjectPage/ProjectPage";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Main} />
        <Route path="/project/:id" component={ProjectPage} />
      </Switch>
    </Router>
  );
}

export default App;
